
import React, { createContext, useContext, useReducer} from "react";

// lo primero es crear nuestro context para poder extraer e ingresar valores
// el provider es una forma de suscripcion
export const StateContext = createContext();

//provider de 3 objetos
export const StateProvider = ({reducer, initialState, children}) => (
    //suscribe a todos los componentes con esas caracteristicas
    <StateContext.Provider value= {useReducer(reducer, initialState)}>
        {children}
    </StateContext.Provider>
);

// useContext te da el acceso ala variable desion global almacenada en el initialState
// voy a tener acceso a todas las variables de sesion que estan en contexto
export const useStateValue = () => useContext(StateContext);
